import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22theme.js%22,%22import%22:%22Roboto_Flex%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22-apple-system%22,%22Segoe%20UI%22,%22Helvetica%20Neue%22,%22Helvetica%22,%22Arial%22,%22Noto%20Sans%22,%22Liberation%20Sans%22,%22sans-serif%22]}],%22variableName%22:%22ROBOTO_FLEX%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Roboto Flex', ui-sans-serif, system-ui, -apple-system, Segoe UI, Helvetica Neue, Helvetica, Arial, Noto Sans, Liberation Sans, sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
